import { WalkthroughEvent, WalkthroughStep } from "./types";
import { WALKTHROUGH_VERSION } from "./walkthroughSteps";

const platform = () => {
  const ua = navigator.userAgent.toLowerCase();
  if (/android/.test(ua)) return "android";
  if (/iphone|ipad|ipod/.test(ua)) return "ios";
  return "web";
};

export function trackWalkthrough(
  event: WalkthroughEvent,
  step: WalkthroughStep | null,
  stepNumber: number,
) {
  const payload = {
    event,
    stepId: step?.id ?? null,
    stepNumber,
    walkthroughVersion: WALKTHROUGH_VERSION,
    platform: platform(),
    device: navigator.userAgent,
    timestamp: new Date().toISOString(),
  };

  window.dispatchEvent(
    new CustomEvent("ekluvya:analytics", { detail: payload }),
  );
  if (process.env.NODE_ENV !== "production") {
    console.debug("[walkthrough]", payload);
  }
}
